<script setup lang="ts">
import { AppStars } from '@libs/ui';

import type { ActivityDetailsMainData } from '../models/activityDetailsMain';

interface ActivityDetailsMainHeaderProps {
  mainInfo: ActivityDetailsMainData;
}
const props = defineProps<ActivityDetailsMainHeaderProps>();
</script>

<template>
  <div class="activity-details-main">
    <span class="activity-name">{{ props.mainInfo.activityName }}</span>
    <span class="activity-destination">
      {{ props.mainInfo.fullDestination }}
    </span>
    <AppStars
      v-if="props.mainInfo.rating"
      :amount="props.mainInfo.rating"
      size="24"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-details-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacin-4);

  .activity-name {
    @include font-heading-3;
    @include for-less-or-equal-than-900-px {
      @include font-heading-5;
      width: 65%;
      max-width: 400px;
    }
    @include for-less-or-equal-than-599-px {
      @include font-heading-5;
      width: 100%;
    }
  }
  .activity-destination {
    @include font-body-l-light;
    @include for-less-or-equal-than-900-px {
      @include font-body-m-light;
    }
  }
}
</style>
